import { createAsyncThunk } from "@reduxjs/toolkit";
import { ContentListAPI, getAreaForContact } from "../../Api/ContactApi";
import { fetchContactStart, fetchContactSuccess, fetchContactFailure, fetchContactSuccessAndSetSelectedEmployee, fetchContactSuccessAndSetSelectedProfessional, fetchContactSuccessAndSetSelectedComClient, fetchContactSuccessAndSetSelectedDomClient, fetchContactSuccessAndDeleteProjectComClient } from "../Slices/contactSlice";
import { AppDispatch } from "../Store";
import { mapEmployeeAreaLists } from "../Types/EmployeeInterface";

export const fetchAllContact = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await ContentListAPI();
        if(data.status){
            dispatch(fetchContactSuccess(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}

export const fetchAllContactAfterEditEmployeeDetails = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await ContentListAPI();
        if(data.status){
            dispatch(fetchContactSuccessAndSetSelectedEmployee(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}

export const fetchAllContactAfterEditProfessionalDetails = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await ContentListAPI();
        if(data.status){
            dispatch(fetchContactSuccessAndSetSelectedProfessional(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}

export const fetchAllContactAfterEditClientDetails = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await ContentListAPI();
        if(data.status){
            dispatch(fetchContactSuccessAndSetSelectedComClient(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}


export const fetchContactSuccessAfterDeleteProjectComClient = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await ContentListAPI();
        if(data.status){
            dispatch(fetchContactSuccessAndDeleteProjectComClient(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}

export const fetchAllContactAfterEditDomClientDetails = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await ContentListAPI();
        if(data.status){
            dispatch(fetchContactSuccessAndSetSelectedDomClient(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}


// get Contact area list
export const getContactAreaList = createAsyncThunk('getContactAreaList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAreaForContact();
    if (response.status) {
      return mapEmployeeAreaLists(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});


